import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducer, adminDashboardFeatureKey } from './admin.reducer';
import { AdminEffects } from './admin.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(adminDashboardFeatureKey, reducer),
    EffectsModule.forFeature([AdminEffects])
  ]
})
export class AdminDashboardStoreModule {}